var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Philippines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M44,24H30.87l0.007,0.005L9.611,37.87C13.249,41.643,18.345,44,24,44C35.046,44,44,35.046,44,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M44,24c0-11.046-8.954-20-20-20c-5.656,0-10.753,2.357-14.39,6.131L30.87,24H44z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M30.87,24L9.61,10.131C6.143,13.727,4,18.61,4,24c0,5.391,2.143,10.274,5.611,13.87l21.266-13.866 L30.87,24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M9.181,13l0.465,0.988l1.035,0.156l-0.75,0.77L10.111,16l-0.93-0.512L8.251,16l0.18-1.086l-0.75-0.77 l1.035-0.156L9.181,13z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M9.466,32.07l0.465,0.992l1.035,0.156l-0.75,0.77l0.18,1.082l-0.93-0.508L8.54,35.07l0.176-1.082 l-0.75-0.77l1.039-0.156L9.466,32.07z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M24.146,22.324l0.461,0.988l1.039,0.156l-0.75,0.77l0.176,1.086l-0.926-0.512l-0.93,0.512l0.18-1.086 l-0.75-0.77l1.035-0.156L24.146,22.324z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M17.681,24c0,1.656-1.344,3-3,3s-3-1.344-3-3s1.344-3,3-3S17.681,22.344,17.681,24z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M15.681,29c0,0.555-0.445,1-1,1c-0.555,0-1-0.445-1-1l1-1.996V21l-1-2c0-0.555,0.445-1,1-1 c0.555,0,1,0.445,1,1l-1,2v6.004L15.681,29z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M19.681,23c0.555,0,1,0.445,1,1s-0.445,1-1,1l-1.996-1h-6.004l-2,1c-0.555,0-1-0.445-1-1s0.445-1,1-1 l2,1h6.004L19.681,23z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M10.439,21.172c-0.395-0.391-0.395-1.023,0-1.414c0.391-0.391,1.023-0.391,1.414,0l0.703,2.121 l4.246,4.242l2.121,0.707c0.391,0.391,0.391,1.023,0,1.414s-1.023,0.391-1.414,0l-0.707-2.121l-4.246-4.242L10.439,21.172z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffa000",
    d: "M17.509,19.758c0.391-0.391,1.023-0.391,1.414,0s0.391,1.023,0,1.414l-2.121,0.707l-4.242,4.242 l-0.707,2.121c-0.391,0.391-1.023,0.391-1.414,0s-0.391-1.023,0-1.414l2.121-0.707l4.242-4.242L17.509,19.758z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Philippines);
export default __webpack_public_path__ + "static/media/icons8-philippines.e591757aeebb67f33764fd3b28651d3f.svg";
export { ForwardRef as ReactComponent };